<!--
Modal component with customizable slots and CSS transitions.
-->

<script>
import deletePvFieldsModal from './deletePvFieldsGMapModalContent.vue'

export default {
  name: 'deletePvFieldsButtonAndModal',
  components: {
    deletePvFieldsModal
  },
  props: ['idfield', 'routesubmit'],
  data() {
    return {
      showModalDelete: false
    }
  },
  methods: {
    afficheModalDelete() {
      this.showModalDelete = true;
    },
    closeModalDelete() {
      this.showModalDelete = false;
    }
  }
}
</script>

<template>
  <div>
    <button id="show-modal-delete" class="buttonOriginal" @click="afficheModalDelete"><span class="glyphicon glyphicon-trash" :title="trans.get('common.delete')"></span></button>

      <!-- use the modal component, pass in the prop -->
      <deletePvFieldsModal v-if="showModalDelete" @close="closeModalDelete" :routesubmit="this.routesubmit"  :idfield="this.idfield"></deletePvFieldsModal>
  </div>
</template>